import { createFileRoute } from '@tanstack/react-router';
import { redirectToArio } from './-redirect';

/** @desc `/admin/automations/<anything>` → `/admin/ario/<anything>` (D2). */
export const Route = createFileRoute('/_protected/admin/automations/$')({
  beforeLoad: ({ params, location }) => redirectToArio({ splat: params._splat ?? '', location }),
});
